export default "__VITE_ASSET__07741954__"